import { render, staticRenderFns } from "./BuildingEditLotTab.vue?vue&type=template&id=dea4a75e"
import script from "./BuildingEditLotTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditLotTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports